
import { createClient } from 'https://esm.sh/@supabase/supabase-js@2.39.7';

const getEnv = (key: string): string => {
  const viteKey = `VITE_${key}`;

  // 1. ลองดึงจาก import.meta.env (มาตรฐาน Vite/Vercel)
  // @ts-ignore
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    // @ts-ignore
    if (import.meta.env[viteKey]) return import.meta.env[viteKey];
    // @ts-ignore
    if (import.meta.env[key]) return import.meta.env[key];
  }

  // 2. ลองดึงจาก process.env (Vercel Build-time / Node)
  if (typeof process !== 'undefined' && process.env) {
    if (process.env[viteKey]) return process.env[viteKey] as string;
    if (process.env[key]) return process.env[key] as string;
  }
  
  // 3. ลองดึงจาก window.process.env (Shim จาก index.html)
  // @ts-ignore
  const shim = window.process?.env;
  if (shim) {
    if (shim[viteKey]) return shim[viteKey];
    if (shim[key]) return shim[key];
  }

  return '';
};

// ดึงค่า URL และ Key โดยไม่มีค่า Default ที่เป็น placeholder เพื่อป้องกันการเรียก URL ผิดพลาด
const supabaseUrl = getEnv('SUPABASE_URL');
const supabaseAnonKey = getEnv('SUPABASE_ANON_KEY');

if (!supabaseUrl || supabaseUrl.includes('your-project-url')) {
  console.warn('Supabase URL is missing or using placeholder. Please check Vercel Environment Variables.');
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder-fill-env-vars.supabase.co', 
  supabaseAnonKey || 'placeholder-key'
);
